// import React, { useState, useEffect } from 'react';
// import { useFormContext } from 'react-hook-form';
// import { useLanguage } from '../../../../context/LanguageContext';
// import { Eye, EyeOff } from 'lucide-react';

// export default function Step3AccountDetails() {
//   const {
//     register,
//     watch,
//     setValue,
//     formState: { errors, touchedFields, isSubmitted },
//   } = useFormContext();
//   const { translate, language } = useLanguage();
//   const [showPassword, setShowPassword] = useState(false);
//   const isRTL = language === 'ar';

//   const countries = [
//     { code: "ae", name: "UAE", flag: "🇦🇪", dialCode: "+971" },
//     { code: "pk", name: "Pakistan", flag: "🇵🇰", dialCode: "+92" },
//     { code: "om", name: "Oman", flag: "🇴🇲", dialCode: "+968" },
//     { code: "kz", name: "Kazakhstan", flag: "🇰🇿", dialCode: "+7" },
//     { code: "iq", name: "Iraq", flag: "🇮🇶", dialCode: "+964" },
//     { code: "us", name: "USA", flag: "🇺🇸", dialCode: "+1" },
//   ];

//   // Local state for the custom input
//   const [selectedCountry, setSelectedCountry] = useState("ae");
//   const [localPhone, setLocalPhone] = useState("");

//   // Get current value from form state (e.g., when coming back to this step)
//   const currentFullPhone = watch('phoneNumber') || "";

//   // Initialize local states from form state on mount
//   useEffect(() => {
//     if (currentFullPhone) {
//       // Find which dial code matches the start of the current phone number
//       const matchedCountry = countries.find(c => currentFullPhone.startsWith(c.dialCode));
//       if (matchedCountry) {
//         setSelectedCountry(matchedCountry.code);
//         setLocalPhone(currentFullPhone.slice(matchedCountry.dialCode.length));
//       } else {
//         // Fallback or handle cases without dial code
//         setLocalPhone(currentFullPhone);
//       }
//     }
//   }, []); // Run once on mount

//   // Update main form state when local state changes
//   const updateMainForm = (countryCode, localPart) => {
//     const selected = countries.find(c => c.code === countryCode);
//     const dialCode = selected?.dialCode || "";
//     const cleanLocalPart = localPart.replace(/\s+/g, "");
//     setValue('phoneNumber', `${dialCode}${cleanLocalPart}`, {
//       shouldValidate: true,
//       shouldDirty: true,
//       shouldTouch: true,
//     });
//   };

//   const handleCountryChange = (e) => {
//     const newCountry = e.target.value;
//     setSelectedCountry(newCountry);
//     updateMainForm(newCountry, localPhone);
//   };

//   const handleLocalPhoneChange = (e) => {
//     const value = e.target.value.replace(/\D/g, ""); // Keep only digits
//     setLocalPhone(value);
//     updateMainForm(selectedCountry, value);
//   };

//   return (
//     <div className="space-y-6">
//       <div className="text-center">
//         <h2 className="text-2xl font-bold text-white mb-2">
//           {translate("auth.signup.accountDetails")}
//         </h2>
//         <p className="text-white">
//           {translate("auth.signup.enterAccountInfo")}
//         </p>
//       </div>

//       <div className="space-y-4">
//         {/* Full Name */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             {translate("auth.signup.fullName")} <span className="text-red-500">*</span>
//           </label>
//           <input
//             {...register('fullName')}
//             type="text"
//             placeholder={translate("auth.signup.fullNamePlaceholder")}
//             className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
//           />
//           {(touchedFields.fullName || isSubmitted) && errors.fullName && (
//             <p className="text-red-500 text-sm mt-1">
//               {String(errors.fullName.message)}
//             </p>
//           )}
//         </div>

//         {/* Phone Number - Custom RegisterForm.jsx Style */}
//         <div className="mb-4">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             {translate("auth.signup.phoneNumber")} <span className="text-red-500">*</span>
//           </label>
//           <div className="flex">
//             <div className="flex w-full h-12 border border-[#13131399] rounded-lg bg-bg-blue overflow-hidden focus-within:ring-2 focus-within:ring-primary">
//               {/* Country Code Select with Flag */}
//               <div className="relative">
//                 <div className="absolute left-2 top-1/2 transform -translate-y-1/2 w-10 h-5">
//                   <img
//                     src={`https://flagcdn.com/w40/${selectedCountry.toLowerCase()}.png`}
//                     alt="flag"
//                     className="w-full h-full object-cover rounded-sm"
//                   />
//                 </div>
//                 <select
//                   value={selectedCountry}
//                   onChange={handleCountryChange}
//                  className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
//                 >
//                   {countries
//                     .sort((a, b) => a.dialCode.localeCompare(b.dialCode))
//                     .map((country) => (
//                       <option key={country.code} value={country.code}>
//                         {country.dialCode}
//                       </option>
//                     ))}
//                 </select>
//               </div>

//               {/* Phone Number Input */}
//               <input
//                 type="tel"
//                 value={localPhone}
//                 onChange={handleLocalPhoneChange}
//                 placeholder={translate("auth.signup.phonePlaceholder") || "2 234 5678"}
//                 maxLength="15"
//             className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2  focus:border-transparent transition-all"
//               />
//             </div>
//           </div>
//           {(touchedFields.phoneNumber || isSubmitted) && errors.phoneNumber && (
//             <p className="text-red-500 text-sm mt-1">
//               {String(errors.phoneNumber.message)}
//             </p>
//           )}
//         </div>

//         {/* Email */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             {translate("auth.signup.email")} <span className="text-red-500">*</span>
//           </label>
//           <input
//             {...register('email')}
//             type="email"
//             placeholder={translate("auth.signup.emailPlaceholder")}
//            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
//           />
//           {(touchedFields.email || isSubmitted) && errors.email && (
//             <p className="text-red-500 text-sm mt-1">
//               {String(errors.email.message)}
//             </p>
//           )}
//         </div>

//         {/* Password */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             {translate("auth.signup.password")} <span className="text-red-500">*</span>
//           </label>
//           <div className="relative">
//             <input
//               {...register('password')}
//               type={showPassword ? "text" : "password"}
//               placeholder={translate("auth.signup.passwordPlaceholder")}
//             className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
//             />
//             <button
//               type="button"
//               onClick={() => setShowPassword(!showPassword)}
//               className={`absolute top-1/2 -translate-y-1/2 text-gray-500 hover:text-primary transition-colors ${isRTL ? "left-4" : "right-4"
//                 }`}
//             >
//               {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//             </button>
//           </div>
//           {(touchedFields.password || isSubmitted) && errors.password && (
//             <p className="text-red-500 text-sm mt-1">
//               {String(errors.password.message)}
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLanguage } from '../../../../context/LanguageContext';
import { Eye, EyeOff } from 'lucide-react';
import PhoneInput from 'react-phone-input-2';
// Import this to ensure base styles are loaded
import 'react-phone-input-2/lib/style.css';

export default function Step3AccountDetails() {
  const {
    register,
    watch,
    setValue,
    formState: { errors, touchedFields, isSubmitted },
  } = useFormContext();

  const { translate, language } = useLanguage();
  const [showPassword, setShowPassword] = useState(false);
  const isRTL = language === 'ar';

  const phoneValue = watch('phoneNumber') || '';

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-white mb-2">
          {translate("auth.signup.accountDetails")}
        </h2>
        <p className="text-gray-300">
          {translate("auth.signup.enterAccountInfo")}
        </p>
      </div>

      <div className="space-y-5">
        {/* Full Name */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1.5">
            {translate("auth.signup.fullName")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('fullName')}
            type="text"
            placeholder={translate("auth.signup.fullNamePlaceholder")}
            className="w-full px-4 py-3 bg-bg-blue border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500/50 transition-all"
          />
          {(touchedFields.fullName || isSubmitted) && errors.fullName && (
            <p className="text-red-500 text-sm mt-1.5">{errors.fullName.message}</p>
          )}
        </div>

      
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1.5">
            {translate("auth.signup.phoneNumber")} <span className="text-red-500">*</span>
          </label>
          <div className="phone-input-wrapper relative overflow-visible">
            <PhoneInput
              country="iq"
              value={phoneValue}
              onChange={(phone) => {
                setValue('phoneNumber', phone, {
                  shouldValidate: true,
                  shouldDirty: true,
                  shouldTouch: true,
                });
              }}
              placeholder={translate("auth.signup.phonePlaceholder") || "Enter phone number"}
              containerClass="!w-full"
              inputClass="!w-full !h-[50px] !bg-bg-blue !text-white !border-gray-700 !rounded-lg focus:!ring-2 focus:!ring-blue-500 !pl-14 !cursor-text"
              buttonClass="!bg-transparent !border-gray-700 !border-r-0 !rounded-l-lg "

              // ── Dropdown container ──
              dropdownClass={`
    !z-50
    !bg-gray-900           /* main dropdown bg */
    !text-white
    !border
    !border-gray-700
    !rounded-lg
    !shadow-2xl
    !max-h-[320px]
    !overflow-y-auto
    scrollbar-thin
    scrollbar-thumb-gray-600
    scrollbar-track-gray-900
    
    /* Force remove white/light bg on items & hover */
    [&_.country]:!bg-gray-900
    [&_.country]:!text-white
    [&_.country:hover]:!bg-gray-800     /* dark hover - no white */
    [&_.country.highlight]:!bg-gray-800 /* selected/highlighted item */
    [&_.country.highlight:hover]:!bg-gray-700
    
    /* Search input if enabled */
    [&_.search]:!bg-gray-800
    [&_.search]:!text-white
    [&_.search]:!border-gray-700
    [&_.search]:placeholder:!text-gray-400
  `}

              dropdownStyle={{
                backgroundColor: '#111827',   // gray-900
                color: 'white',
                border: '1px solid #374151',  // gray-700
                borderRadius: '0.5rem',
                boxShadow: '0 20px 25px -5px rgba(0,0,0,0.5), 0 8px 10px -6px rgba(0,0,0,0.5)',
              }}
              // Optional: search field styling (if enableSearch=true)
              searchClass="!bg-gray-800 !text-white !border-gray-700 !placeholder-gray-400"
              searchStyle={{
                backgroundColor: '#1f2937',
                color: 'white',
                borderBottom: '1px solid #374151',
              }}

              // If the lib supports these (some forks do), try:
              // countryClass="!bg-transparent hover:!bg-gray-800"
              // But usually not deep enough → rely on dropdownClass arbitrary selectors above

              inputProps={{
                name: 'phoneNumber',
                required: true,
                autoComplete: 'tel',
              }}
            />
          </div>
          {(touchedFields.phoneNumber || isSubmitted) && errors.phoneNumber && (
            <p className="text-red-500 text-sm mt-1.5">{errors.phoneNumber.message}</p>
          )}



        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1.5">
            {translate("auth.signup.email")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('email')}
            type="email"
            placeholder={translate("auth.signup.emailPlaceholder")}
            className="w-full px-4 py-3 bg-bg-blue border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500/50 transition-all"
          />
          {(touchedFields.email || isSubmitted) && errors.email && (
            <p className="text-red-500 text-sm mt-1.5">{errors.email.message}</p>
          )}
        </div>

        {/* Password */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1.5">
            {translate("auth.signup.password")} <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              {...register('password')}
              type={showPassword ? 'text' : 'password'}
              placeholder={translate("auth.signup.passwordPlaceholder")}
              className="w-full px-4 py-3 bg-bg-blue border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500/50 transition-all"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className={`absolute top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-400 transition-colors ${isRTL ? 'left-4' : 'right-4'
                }`}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
          {(touchedFields.password || isSubmitted) && errors.password && (
            <p className="text-red-500 text-sm mt-1.5">{errors.password.message}</p>
          )}
        </div>
      </div>
    </div >
  );
}